import React, { useEffect, useState, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import QuatationServices from "../../../services/QuatationServices";

const QuatationLogModal = ({ show, handleClose, partNo }) => {
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);

  const fetchLogs = useCallback(async () => {
    if (!partNo) return;

    try {
      setLoading(true);
      const res = await QuatationServices.getApprovalLogs(partNo);
      setLogs(res.data);
    } catch (err) {
      Swal.fire("Failed to load quotation history");
    } finally {
      setLoading(false);
    }
  }, [partNo]);

  useEffect(() => {
    if (show) fetchLogs();
  }, [show, fetchLogs]);

  const formatDate = date => {
    if (!date) return "-";
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()}`;
  };

  const actionBadge = action => {
    if (action === "Approved") return "bg-success";
    if (action === "Expired") return "bg-danger";
    if (action === "Reactivated") return "bg-warning";
    return "bg-secondary";
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header>
        <Modal.Title>Quotation History — Part No: {partNo}</Modal.Title>
        <Button variant="" className="btn-close" onClick={handleClose} />
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>

        {loading ? (
          <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: 250 }}>
            <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} />
            <p className="mt-3 fw-semibold text-primary">Loading history...</p>
          </div>
        ) : (

          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Supplier</th>
                <th>Rate</th>
                <th>Unit</th>
                <th>Source</th>
                <th>Status Flow</th>
                <th>Expiry Date</th>
                <th>Action Date</th>
                <th>Action By</th>
              </tr>
            </thead>

            <tbody>
              {logs.length ? (
                logs.map((log, i) => (
                  <tr key={i}>
                    <td>{log?.supplierId?.name || "-"}</td>
                    <td>₹ {log?.rate}</td>
                    <td>{log?.unit}</td>
                    <td>{log?.source || "-"}</td>

                    <td>
                      {log?.previousStatus && log?.newStatus ? (
                        <span className="fw-semibold text-muted">
                          {log.previousStatus} → {log.newStatus}
                        </span>
                      ) : (
                        <span className={`badge ${actionBadge(log?.action)}`}>
                          {log?.action}
                        </span>
                      )}
                    </td>

                    <td>{log?.expiryDate ? formatDate(log.expiryDate) : "-"}</td>
                    <td>{formatDate(log?.actionAt)}</td>
                    <td>{log?.actionBy?.name || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center text-muted">
                    No history found for this part number
                  </td>
                </tr>
              )}
            </tbody>
          </table>

        )}

      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QuatationLogModal;
